import { IPersonaProps as FIPersonaProps, IPersonaStyles, Persona as FPersona } from '@fluentui/react';
import { forwardRef, Ref } from 'react';

import { IComponent } from '../../models/components.models';
import { useThemeStyles } from '../../utils/hooks';
import { personaStylesDefault } from './Persona.styles';

export interface IPersonaProps extends Omit<FIPersonaProps, 'styles'>, IComponent<IPersonaStyles> {}

export const Persona = forwardRef((props: IPersonaProps, ref: Ref<HTMLDivElement>) => {
  const { styles, ..._fProps } = props;
  const fProps: FIPersonaProps = {
    ..._fProps,
    styles: useThemeStyles<IPersonaStyles>(personaStylesDefault, styles),
  };
  return <FPersona {...fProps} ref={ref} data-test={props['data-test'] || 'persona'} />;
});
